import ABCyaLib from "@abcya/abcya_lib";
import Utils from "./Utils.js";

export default class InputHelper {
  static get KeyCodes() {
    return Phaser.Input.Keyboard.KeyCodes;
  }

  static deadCode = null;

  /**
   * @param {function(InputHelper.KeyCodes, String, Boolean, Boolean, Boolean)} func (InputHelper.KeyCodes, key, ctrlDown, altDown, shiftDown)
   */
  static GetKeyCodes(func) {
    const specialCharMap = {
      "KeyE": {
         "a": "á",
         "e": "é",
         "i": "í",
         "o": "ó",
         "u": "ú",
      },
      "KeyU": { "u": "ü" },
      "KeyN": { "n": "ñ" }
    }

    Utils.scene.input.keyboard.on('keydown', (event) => {
      let specialKey = null;

      // only check dead keys on MacOS; deadCode must be set; key being pressed can't be shift key
      if (ABCyaLib.DEVICE_INFO.macOS && this.deadCode !== null && event.key !== "Shift") {
        specialKey = specialCharMap[this.deadCode]?.[event.key.toLocaleLowerCase()];
        
        if(specialKey && (event.shiftKey || event.getModifierState("CapsLock"))) {
          specialKey = specialKey.toLocaleUpperCase(); 
        }
        this.deadCode = null;
      }

      func(event.keyCode, specialKey ?? event.key, event.ctrlKey, event.altKey, event.shiftKey);
      event.preventDefault();
    });

    if (ABCyaLib.DEVICE_INFO.macOS) {
      Utils.scene.input.keyboard.on('keyup', (event) => {
        if (event.key === "Dead" && specialCharMap[event.code] !== undefined) {
          //if there's a dead key, record it to be checked on the next down event
          this.deadCode = event.code;
        }
        event.preventDefault();
      });
    }
  }
}